<template>
  <div style="height: 100%; width: 100%; display: flex; flex-direction: row; justify-content: flex-start;">
    <div style="display: flex; flex-direction: row; width: 100%;">
      <div style=" display: flex; flex-direction: row;">
        {{label}}<div style="display: inline-block;">:</div>
      </div>
      <input
        class="simple-number-input"
        :id="`${identifier}`"
        style=""
        type="number"
        v-model="value"
        @blur="editing = false"
        v-if="editing"
        :min="min"
        :max="max"
        :identifier="`${identifier}-number`"
        @change="handleInput">
      <div
        v-else-if="!editing"
        @click="editing = true"
        style="padding-left: .5rem; cursor: pointer;"
        class="editable-input"
        >
        {{value}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormNumberInput',
  props: {
    identifier: {
      required: true,
    },
    initialValue: {
      required: true,
    },
    label: String,
    min: Number,
    max: Number,
    options: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      editing: false,
      value: undefined,
      textInputCharacterCount: undefined,
    }
  },
  methods: {
    handleInput (event) {
      this.value = event.target.value
      this.$emit('change', event.target.value)
    },
  },
  computed: {
  },
  mounted () {
    this.value = this.initialValue
  },
}
</script>

<style>
</style>
